import {
  first_present,
  normalize_key,
  normalize_text,
} from './company_cases_common';

const RISK_THRESHOLDS = [
  { minimum: 70, label: 'High' },
  { minimum: 40, label: 'Mid' },
  { minimum: 0, label: 'Low' },
];

function is_positive_score(score) {
  return Number.isFinite(score) && score > 0;
}

export function risk_label_for_score(score, fallback = '') {
  const fallback_label = normalize_text(fallback);
  if (fallback_label) return fallback_label;

  const numeric_score = Number(score);
  if (!is_positive_score(numeric_score)) return '';
  return RISK_THRESHOLDS.find(({ minimum }) => numeric_score >= minimum)?.label || 'Low';
}

const RISK_BADGE_RULES = [
  {
    class_name: 'bg-danger-subtle text-danger-emphasis',
    matches: (label, score) => label.includes('high') || score >= 70,
  },
  {
    class_name: 'bg-warning-subtle text-warning-emphasis',
    matches: (label, score) =>
      ['mid', 'medium'].some((key) => label.includes(key)) || score >= 40,
  },
  {
    class_name: 'bg-success-subtle text-success-emphasis',
    matches: (label, score) => label.includes('low') || is_positive_score(score),
  },
];

export function risk_badge_class(label = '', score = '') {
  const normalized_label = normalize_key(label);
  const numeric_score = Number(score);
  return RISK_BADGE_RULES.find((rule) => rule.matches(normalized_label, numeric_score))?.class_name
    || 'bg-light text-secondary';
}

export function risk_details(record = {}) {
  const score = normalize_text(first_present([
    record?.total_score,
    record?.risk_score,
    record?.score,
    record?.risk,
  ]));
  const numeric_score = Number(score);
  const label = risk_label_for_score(score, first_present([
    record?.risk_level,
    record?.risk_label,
    record?.risk_band,
    record?.category?.risk_level,
    record?.category?.name,
    record?.category,
  ]));
  const normalized_score = Number.isFinite(numeric_score) ? String(numeric_score) : score || '0';

  return {
    risk_score: normalized_score,
    risk_label: label,
    risk_badge_class: risk_badge_class(label, normalized_score),
  };
}
